import React from "react";
import { Container } from "react-bootstrap";

const WhyChoose = ({ header, items, className }) => {
    const cards =
        items?.filter(({ title, description }) => title || description) || [];

    if (!header && cards.length === 0) return null;

    return (
        <section className={`why-choose ${className || ""}`}>
            <Container>
                {header && <h2 className="why-choose__header">{header}</h2>}

                {cards.length > 0 && (
                    <div className="why-choose__grid">
                        {cards.map(({ title, description }, index) => (
                            <div className="why-choose__card" key={index}>
                                {title && (
                                    <h3 className="why-choose__title">
                                        {title}
                                    </h3>
                                )}
                                {description && (
                                    <p className="why-choose__text">
                                        {description}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </Container>
        </section>
    );
};

export default WhyChoose;
